import { TriangleAlertIcon } from "lucide-react"
import { PageBody, PageHeader, RefusalState } from "@/design-system/index.ts"

/*
 * What a route shows when rendering or loading it throws: most often a page's code that a new
 * deploy has replaced, which a reload fetches afresh. The error itself stays in the browser — it
 * may hold what a Member typed — so nothing here reports it anywhere.
 */

const reload = () => window.location.reload()

/** A route's failure inside the shell's panel, under a header of its own. */
export function RouteError() {
  return (
    <>
      <PageHeader
        crumbs={[
          { label: "Something went wrong", glyph: { kind: "icon", icon: TriangleAlertIcon } },
        ]}
      />
      <PageBody width="document">
        <RefusalState refusal="unknown" onRetry={reload} />
      </PageBody>
    </>
  )
}

/** The shell's own failure, on the bare canvas, since there is no shell to put it in. */
export function ShellError({ onRetry = reload }: { onRetry?: () => void }) {
  return (
    <main className="grid min-h-svh place-items-center bg-sidebar px-4">
      <div className="w-md rounded-xl bg-background px-8 shadow-dialog">
        <RefusalState refusal="unknown" onRetry={onRetry} />
      </div>
    </main>
  )
}
